import { BaseMarkerController } from '../base/baseMarkerController'
import { BezierLineMarker } from './bezierLineMarker'
import { MarkerModes } from '../../types'

class BezierLineMarkerController extends BaseMarkerController<BezierLineMarker> {
  constructor(marker: BezierLineMarker) {
    super()
    this.marker = marker
  }

  /**
   * Called by p5 main event loop when key is pressed.
   */
  keyPressedEvent(): void {
    const marker = this.marker
    const state = marker.state
    const p = marker.p
    if (p.keyCode === p.ESCAPE) {
      if (state.mode === MarkerModes.Create) {
        state.mode = MarkerModes.Edit
        marker.markerCreatedCallback(marker)
      }
      if (state.mode === MarkerModes.Edit) {
        state.mode = MarkerModes.Display
      }
    }
  }

  mouseDraggedEvent(): void {
    const state = this.marker.state
    super.mouseDraggedEvent()
    if (state.pressedHandle) {
      state.pressedHandle.handleDrag(this.mouseDelta.x, this.mouseDelta.y)
    } else if (state.isPressed) {
      state.moveMarker(this.mouseDelta.x, this.mouseDelta.y)
    }
    if ((state.pressedHandle || state.isPressed) && state.mode !== MarkerModes.Create)
      this.marker.markerEditCallback(this.marker)
  }

  mouseMovedEvent(): void {
    super.mouseMovedEvent()
  }

  mousePressedEvent(): void {
    const state = this.marker.state

    super.mousePressedEvent()
    if (state.mode === MarkerModes.Create && !state.pressedHandle) {
      const mousePosition = { x: this.mouseCoordinateX, y: this.mouseCoordinateY }
      state.appendVertex(mousePosition)
    }

    if (state.pressedHandle) {
      state.pressedHandle.handlePress()
    }
  }

  mouseReleasedEvent(): void {
    super.mouseReleasedEvent()
  }
}

export { BezierLineMarkerController }
